// @flow

import React, { useContext, Fragment } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { wrapperPaddings } from '@riseart/layout';
import { SSRContext } from 'shared_data/providers/ssr/Context';
import { HOCArtsGrid } from 'shared_hocs/arts/Grid';
import { useUrlParams } from 'shared_data/providers/url/useUrlParams';
import HOCFilterPageRoute from 'shared_hocs/routes/FilterPageRoute';
import { ArtListSection } from 'shared_components/arts/containers/sections/List';
import { CollectionFiltersArt } from 'shared_components/collections/containers/filters/Art';
import { HOCFilterContainer } from 'shared_hocs/filters/Container';
import FILTER_COLLECTION_ART_QUERY from 'shared_data/queries/filter/collectionArt.graphql';
import {
  pagination as PAGINATION_ENUM,
  filter as FILTER_ENUM,
  analytics as ENUM_ANALYTICS,
} from 'Enum';

const hocConfigOptions = {
  domain: FILTER_ENUM.domain.COLLECTION_ART,
};

const HOCCollectionArtsGrid = HOCArtsGrid(ArtListSection, hocConfigOptions);

const HOCArtsFiltersContainer = HOCFilterContainer(CollectionFiltersArt, hocConfigOptions);

/**
 * CollectionDetailsArt
 *
 * @param {Object} props
 * @returns {Node}
 */
const CollectionDetailsArt = (props: Object) => {
  const { isSSR } = useContext(SSRContext);

  return (
    <Fragment>
      <HOCArtsFiltersContainer
        urlParams={props.urlParams}
        domain={props.domain}
        additionalFilterQueryParams={{ collectionId: props.match.params.id }}
      />
      <HOCCollectionArtsGrid
        includeLDJSON
        isSSR={isSSR}
        isSsrQuery
        fetchQuery={FILTER_COLLECTION_ART_QUERY}
        collectionId={props.match.params.id}
        domain={props.domain}
        pageUrl={props.pageUrl}
        wrapperPaddings={wrapperPaddings}
        paginationType={props.paginationType}
        showAddToCart
        tracking={{
          name: ENUM_ANALYTICS.list.name.COLLECTION_ART_GRID,
          enabled: true,
          enableInitial: true,
          enableClick: true,
        }}
      />
    </Fragment>
  );
};

const HOCCollectionDetailsArtPage = HOCFilterPageRoute(
  CollectionDetailsArt,
  FILTER_ENUM.domain.COLLECTION_ART,
);

export function CollectionDetailsArtContainer(props: any) {
  const match = useRouteMatch();
  const { translatedLocation: location } = useUrlParams();

  return (
    <HOCCollectionDetailsArtPage
      {...props}
      match={match}
      location={location}
      paginationType={PAGINATION_ENUM.type.INFINITE}
      domain={FILTER_ENUM.domain[props.routeConfig.filterDomainKey]}
    />
  );
}
